<script>
import { Doughnut, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Doughnut,
  props: ['chartdata'],
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        title: {
          display: true,
          text: '최근 30일 기기별 접속현황',
        },
        plugins: {
          datalabels: {
            color: 'white',
            font: {
              weight: 'bold',
            },
            formatter: function (val, ctx) {
              let sum = ctx.dataset.data[0] + ctx.dataset.data[1];
              let percentage = ((val / sum) * 100).toFixed(0) + '%';
              return percentage;
            }.bind(this),
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {},
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
